
function createTag () {
  return {
    restrict: 'E',
    templateUrl: '/admin/dialogs/create-tag/create-tag.html?$$REVISION$$'
  }
}
export { createTag }
